import React, { useState } from "react";
import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import { Container } from "../../atoms/container/Container";
import { Text } from "../../atoms/text/Text";
import style from "./selectPatient.module.scss";
import { BenSearchByNumber } from "../../molecules/benSearchByNumber/BenSearchByNumber";
import { BenSearchByCompany } from "../../molecules/benSearchByCompnay/BenSearchByCompany";
import { useBeneficiaryData } from "../../../hooks/useBeneficiaryData/useBeneficiaryData";
import { BeneficiaryGrp } from "../benficiaryGrp/BeneficiaryGrp";
import LoadingSpinner from "../../atoms/loader/Loader";
import { AgentScript } from "../../atoms/agentScript/AgentScript";
import { Button } from "../../atoms/button/Button";
import { UseGetStoreData } from "../../../hooks/getStoreData/UseGetStoreData";
import { PatientForm } from "./PatientForm";

export const SelectPatient = () => {
  const [openPatientForm, setOpenPatientForm] = useState(false);
  const { getTicketData, getTicketUpdateData } = UseGetStoreData();

  const {
    benOptions,
    selectedOption,
    handleOptionChange,
    benFindOptions,
    selectedSearchOption,
    handleSearchOptionChange,
    handleSearchByMobile,
    searchBenRes,
    handleSearchResChange,
    selectedOptionSearchRes,
    searchByMobileRes,
    handleSearchByCompany,
    searchRes,
  } = useBeneficiaryData();

  const currentPatient = getTicketUpdateData?.patient || getTicketData?.patient;

  return (
    <>
      <BackgroundWrapper>
        <Container>
          <Container className={style.container}>
            <Text text="Select Patient" className={style.title} />

            {currentPatient?.fullName && (
              <div
                style={{
                  background: "#e6f7ff",
                  border: "1px solid #91d5ff",
                  borderRadius: "8px",
                  padding: "10px 16px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                <div>
                  <span style={{ fontWeight: 600, color: "#0050b3", fontSize: "0.95rem" }}>
                    ✓ Patient Name: {currentPatient.fullName}
                  </span>
                </div>
                <Button
                  text={openPatientForm ? "Close" : "Edit Name"}
                  onClick={() => setOpenPatientForm(!openPatientForm)}
                  className={style.btn}
                  style={{ margin: 0, padding: "4px 12px", fontSize: "0.85rem" }}
                />
              </div>
            )}

            <Text
              text={`Please help me with the patient’s name so that I can proceed.`}
              className={style.question}
            />
            {benOptions.length > 0 ? (
              <BeneficiaryGrp
                column={3}
                gap={1}
                className={style.flex}
                options={benOptions}
                selectedValue={selectedOption}
                onChange={handleOptionChange}
              />
            ) : (
              <span style={{ color: "#8c8c8c", fontSize: "0.9rem" }}>
                No registered beneficiaries linked to this caller. You can add the name below.
              </span>
            )}

            {(!currentPatient?.fullName || getTicketData?.campusId) && (
              <div style={{ marginTop: "0.5rem" }}>
                <Button
                  text={openPatientForm ? "Close Form" : "+ Add Patient Name"}
                  onClick={() => setOpenPatientForm(!openPatientForm)}
                  className={style.btn}
                />
              </div>
            )}

            {openPatientForm && (
              <div
                style={{
                  marginTop: "1rem",
                  padding: "1rem",
                  background: "#fafafa",
                  borderRadius: "8px",
                  border: "1px solid #d9d9d9",
                  width: "100%",
                }}
              >
                <Text text={currentPatient?.fullName ? "Edit Patient Name" : "Enter Patient Name"} className={style.question} />
                <PatientForm
                  ticketId={getTicketData?._id}
                  defaultMobile={
                    getTicketData?.callerID && getTicketData?.callerID !== "N/A"
                      ? getTicketData.callerID
                      : ""
                  }
                  defaultName={currentPatient?.fullName || ""}
                  onPatientSaved={() => setOpenPatientForm(false)}
                  onCancel={() => setOpenPatientForm(false)}
                />
              </div>
            )}
          </Container>

          <Container className={style.container_2}>
            <AgentScript
              text={`If not found: "I am not able to locate the patient in our system. May I have the patient's mobile number so that I can search in our database?"`}
            />
            <Text text="Find Beneficiary" className={style.title} />
            <BeneficiaryGrp
              column={2}
              gap={1}
              className={style.flex}
              options={benFindOptions}
              selectedValue={selectedSearchOption}
              onChange={handleSearchOptionChange}
            />
          </Container>
          <Container className={style.wrapper}>
            {selectedSearchOption &&
              selectedSearchOption === "By Mobile Number" && (
                <BenSearchByNumber
                  handleSearchByMobile={handleSearchByMobile}
                />
              )}
            {selectedSearchOption &&
              selectedSearchOption === "ByCompanyName" && (
                <BenSearchByCompany
                  handleSearchByCompany={handleSearchByCompany}
                />
              )}

            {searchBenRes.length ? (
              <div className={style.container_2}>
                <Text
                  text={`What is the patient’s name ?`}
                  className={style.question}
                />
                <BeneficiaryGrp
                  column={3}
                  gap={1}
                  className={style.flex}
                  options={searchByMobileRes}
                  selectedValue={selectedOptionSearchRes}
                  onChange={handleSearchResChange}
                />
              </div>
            ) : searchRes ? (
              <LoadingSpinner />
            ) : null}
          </Container>
        </Container>
      </BackgroundWrapper>
    </>
  );
};
